import { vservice } from '@niknevis/vue-modules'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'
import {
  ContentItemUpdatableAttributesResourceModel,
  ContentItemUpdatableAttributesResourceTypeInAdmin
} from '@/modules/content-item/models/content-item-resource.model'

@vservice()
export class AdminContentItemGetUpdatableAttributesUseCase {
  constructor(
    private readonly service: AdminContentItemService
  ) {
  }

  public remoteData = RemoteData
    .notAsked<ContentItemUpdatableAttributesResourceTypeInAdmin>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get allData(): ContentItemUpdatableAttributesResourceTypeInAdmin {
    return this.remoteData.fold(
      () => null,
      value => value || null,
      value => value,
      (error, value) => value || null
    )
  }

  get data(): ContentItemUpdatableAttributesResourceModel {
    return this.allData.data
  }

  execute(campaignId: number): RemoteData<ContentItemUpdatableAttributesResourceTypeInAdmin> {
    return this.remoteData.fromPromise(
      this.service.getUpdatableAttributes(campaignId)
    )
  }
}
